import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { ICareplanInfo, IDataSourceBackendParam } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { CareplansApiService } from "src/app/providers/api/careplans-api.service";

export class CareplansDataSource extends MatTableDataSourceBackendExtended<ICareplanInfo> {
  constructor(private careplansApi: CareplansApiService) {
    super();
  }

  public data(params: IDataSourceBackendParam): Observable<ICareplanInfo[]> {
    return this.careplansApi.findCareplans(params) as Observable<ICareplanInfo[]>;
  }
  protected dataCount(_param: IDataSourceBackendParam): Observable<number> {
    /*
    Use this, the day we decide to make careplans-list-page implements AbstractBackendTablePage
    return this.careplansApi.getCareplansCount(param.search, param.filters, param.services).pipe(map((response) => response.count));
    */
    return of(0);
  }
}
